/** ISO date (YYYY-MM-DD) helpers in UTC, so a day never shifts with the viewer's time zone. */

export const isoToDate = (iso: string) => new Date(`${iso}T00:00:00Z`);
export const dateToIso = (d: Date) => d.toISOString().slice(0, 10);

export const addDaysIso = (iso: string, n: number) => {
  const d = isoToDate(iso);
  d.setUTCDate(d.getUTCDate() + n);
  return dateToIso(d);
};

export const nightsBetween = (from: string, to: string) =>
  from && to ? Math.max(0, Math.round((isoToDate(to).getTime() - isoToDate(from).getTime()) / 86400000)) : 0;

/** Today in the viewer's own calendar (not UTC), as an ISO date. */
export const localTodayIso = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
};

export const monthStart = (iso: string) => `${iso.slice(0, 7)}-01`;

export const addMonthsIso = (iso: string, n: number) => {
  const d = isoToDate(monthStart(iso));
  d.setUTCMonth(d.getUTCMonth() + n);
  return dateToIso(d);
};

export const isIsoDate = (v: unknown): v is string => typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v);

/** The days of a month laid out in weeks starting on Monday; null pads the first and last week. */
export function monthGrid(firstOfMonth: string): (string | null)[] {
  const first = isoToDate(firstOfMonth);
  const lead = (first.getUTCDay() + 6) % 7;
  const days = new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0)).getUTCDate();
  const cells: (string | null)[] = Array(lead).fill(null);
  for (let d = 1; d <= days; d++) cells.push(addDaysIso(firstOfMonth, d - 1));
  while (cells.length % 7) cells.push(null);
  return cells;
}
